import React from "react";
import { EditIcon } from "../../SVG/edit-icon";
import { TrashIcon } from "../../SVG/trash-icon";
import "./rule-card.scss";

export interface RuleCardProps {
  content: string;
  index?: number;
  onEdit?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onDelete?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  editIconColor?: string;
  deleteIconColor?: string;
  iconSize?: number;
  className?: string;
  contentClassName?: string;
}

export const RuleCard: React.FC<RuleCardProps> = ({
  content,
  index,
  onEdit,
  onDelete,
  editIconColor = "#0056D6",
  deleteIconColor = "#F50400",
  iconSize = 12,
  className = "",
  contentClassName = "",
}) => {
  const showIndex = index !== undefined;

  return (
    <div className={`rule-card ${showIndex ? "rule-card--indexed" : ""} ${className}`}>
      <div className="rule-card__body">
        <div className="rule-card__content">
          {showIndex && (
            <span className="rule-card__index">#{index}</span>
          )}
          <p className={`rule-card__text ${contentClassName}`}>
            {content}
          </p>
        </div>

        {(onEdit || onDelete) && (
          <div className="rule-card__actions">
            {onEdit && (
              <button
                className="rule-card__action-btn"
                onClick={onEdit}
                type="button"
                aria-label="Edit rule"
              >
                <EditIcon color={editIconColor} size={iconSize} />
              </button>
            )}
            {onDelete && (
              <button
                className="rule-card__action-btn"
                onClick={onDelete}
                type="button"
                aria-label="Delete rule"
              >
                <TrashIcon color={deleteIconColor} size={iconSize} />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
